import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { annualRevenues, businessSector, businessSize, companyCapital, merchantCategory, numberOfEmployees, relationType } from '../../../../shared/utils/data';
import { InputField } from "../../../../shared/ui/input-field/input-field";
import { CustomDropdown } from "../../../../shared/components/custom-dropdown/custom-dropdown";
import { Button } from "../../../../shared/ui/button/button";
import { Sidebar } from '../../../../core/services/sidebar';

@Component({
  selector: 'app-step3-company-information',
  imports: [InputField, CustomDropdown, ReactiveFormsModule, TranslatePipe, Button, CommonModule],
  templateUrl: './step3-company-information.html',
  styleUrl: './step3-company-information.css'
})
export class Step3CompanyInformation implements OnInit {
  @Input() data: any;
  @Input() onboardingStep!: number;
  @Input() onboardingSubStep!: number;
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  businessSectorOptions = businessSector;
  relationTypeOptions = relationType;
  merchantCategoryOptions = merchantCategory;
  businessSizeOptions = businessSize;
  numberOfEmployeesOptions = numberOfEmployees;
  companyCapitalOptions = companyCapital;
  annualRevenuesOptions = annualRevenues;

  companyInformationForm = new FormGroup({
    businessSector: new FormControl('', [Validators.required]),

    businessActivity: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(200)
    ]),

    relationType: new FormControl('', [Validators.required]),

    merchantCategory: new FormControl('', [Validators.required]),

    specifyMerchantActivity: new FormControl(''),

    businessSize: new FormControl('', [Validators.required]),

    numberOfEmployees: new FormControl('', [Validators.required]),

    companyCapital: new FormControl('', [Validators.required]),

    annualRevenues: new FormControl('', [Validators.required]),
  })

  constructor(private sidebarService: Sidebar) {

  }

  ngOnInit(): void {
    this.sidebarService.setLinks([
      { label: 'SIDEBAR.PREVIOUS_SCREEN', action: () => this.goBackStep(), iconPath: 'assets/icons/arrow-blue.svg', variant: 'outlined' },
      { label: 'SIDEBAR.SAVE_EXIT', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }
    ]);
  }

  onDropdownSelect(controlName: string, selectedItem: any) {
    this.companyInformationForm.get(controlName)?.setValue(selectedItem.label);

    if (controlName === 'merchantCategory') {
      if (selectedItem.label === 'Other') {
        this.companyInformationForm.get('specifyMerchantActivity')?.setValidators([
          Validators.required,
          Validators.minLength(3)
        ]);
      } else {
        this.companyInformationForm.get('specifyMerchantActivity')?.clearValidators();
        this.companyInformationForm.get('specifyMerchantActivity')?.setValue('');
      }
      this.companyInformationForm.get('specifyMerchantActivity')?.updateValueAndValidity();
    }
  }


  handleFormSubmission() {
    // console.log('Form submitted!', this.companyInformationForm.value);
    this.next.emit();
  }

  getControl(controlName: string): FormControl {
    return this.companyInformationForm.get(controlName) as FormControl;
  }

  /** Go back to Trade License details */
  goBackStep() {
    this.prev.emit();
  }
}
